/* ==========================================================================
   QUOTATIONS SECTION
   ========================================================================== */

const CURRENT_CLASS = "is-current";
var TIMEOUT: ReturnType<typeof setTimeout>;

for (const carousel of document.querySelectorAll(".carousel")) {
  const viewport = carousel.querySelector(".carousel__slides");
  if (viewport == null) throw new Error("Carousel with no viewport");

  // Get slides, thumbs, pips
  const slides: NodeListOf<HTMLElement> =
    viewport.querySelectorAll(".carousel__slide");

  const nav: HTMLElement | null = carousel.querySelector(".carousel__nav");

  const pips: NodeListOf<HTMLElement> = carousel.querySelectorAll(
    ".carousel__nav .carousel__pips"
  );

  const threshold = 0.5;

  // Get arrows
  const nextArrow = carousel.querySelector<HTMLElement>(".js-next");
  const prevArrow = carousel.querySelector<HTMLElement>(".js-previous");

  if (slides.length <= 1) continue;
  if (slides.length !== pips.length) {
    // throw new Error("Slides length is not the same as pips length");
  }

  // Get current slide
  const getCurrentSlide = (
    slides: NodeListOf<HTMLElement>
  ): number | undefined => {
    let index: (number | undefined)[] = [...slides].map((slide, index) => {
      if (slide.classList.contains(CURRENT_CLASS)) {
        return index;
      } else {
        return;
      }
    });
    index = index.filter((value) => !isNaN(value!));

    return index[0];
  };

  // Scroll setup for slides
  const scrollToSlide = (index: number) => {
    for (const slide of slides) {
      slide.classList.remove(CURRENT_CLASS);
    }
    slides[index].classList.add(CURRENT_CLASS);

    if (nav) {
      if (index == 0) {
        nav.classList.add("first-slide");
      } else {
        nav.classList.remove("first-slide");
      }
      if (index == slides.length - 1) {
        nav.classList.add("last-slide");
      } else {
        nav.classList.remove("last-slide");
      }
    }

    viewport.scrollTo({
      left: slides[index].offsetLeft,
      behavior: "smooth",
    });
  };

  // Handle clicks on slide pips
  if (pips) {
    for (const [index, pip] of pips.entries()) {
      pip.addEventListener("click", () => {
        scrollToSlide(index);
      });
    }
  }

  // Arrows for slides
  nextArrow?.addEventListener("click", () => {
    const nextSlide =
      getCurrentSlide(slides)! + 1 > slides.length - 1
        ? 0
        : getCurrentSlide(slides)! + 1;
    scrollToSlide(nextSlide);
  });

  prevArrow?.addEventListener("click", () => {
    const prevSlide =
      getCurrentSlide(slides)! - 1 < 0
        ? slides.length - 1
        : getCurrentSlide(slides)! - 1;
    scrollToSlide(prevSlide);
  });

  // Keep track of which slide is current
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        const index = [...slides].findIndex((slide) => slide === entry.target);
        if (index === -1) continue;
        const pip = pips[index];
        if (pip) {
          pip.classList.toggle(
            CURRENT_CLASS,
            entry.intersectionRatio >= threshold
          );
        }
      }
    },
    {
      root: viewport,
      threshold: threshold,
    }
  );
  for (const slide of slides) {
    observer.observe(slide);
  }

  window.addEventListener("load", () => {
    const index = [...pips].findIndex((pip) =>
      pip.classList.contains(CURRENT_CLASS)
    );
    scrollToSlide(Math.max(0, index));
  });

  // Scroll current slide into view on resize
  window.addEventListener("resize", () => {
    const index = [...pips].findIndex((pip) =>
      pip.classList.contains(CURRENT_CLASS)
    );
    scrollToSlide(Math.max(0, index));
  });
}
